module.exports = __webpack_public_path__ + "img/adulto14.e042a1ea.jpg";